const pcpLendersIntegrated = [
  50, 66, 67, 70, 73, 74, 75
]

const allPcpLenders = [
  50, 66, 67, 70, 73, 74, 75
]

export {
  pcpLendersIntegrated,
  allPcpLenders
}
